import {apiInstance} from '../api_Instance';
import {queryOptions} from '@tanstack/react-query';

const cat_desc_api = {
  getCatDesc: (id) => {
    return queryOptions({
      queryKey: ['cat-desc', id],
      queryFn: () => apiInstance.get(`/subcategories/${id}`),
      select: (data) => data.data,
    });
  },
};
export const {getCatDesc} = cat_desc_api;
